import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StashCategory } from '@stash/shared-types';
import { fetchCategoriesAsync } from '../actions/category-actions';

export interface CategoriesState {
  categories: StashCategory[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CategoriesState = {
  categories: [],
  isLoading: false,
  error: null,
};

const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesAsync.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCategoriesAsync.fulfilled, (state, action: PayloadAction<StashCategory[]>) => {
        state.isLoading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategoriesAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default categorySlice.reducer;
